// extracted by mini-css-extract-plugin
export var box = "checkbox-group-module--box--ac843";
export var check = "checkbox-group-module--check--fc1b6";
export var container = "checkbox-group-module--container--d1477";
export var dark = "checkbox-group-module--dark--7b3ab";
export var disabled = "checkbox-group-module--disabled--4b19d";
export var iconWrapper = "checkbox-group-module--icon-wrapper--29880";
export var input = "checkbox-group-module--input--4a634";
export var label = "checkbox-group-module--label--e632e";
export var radio = "checkbox-group-module--radio--3f691";
export var withIcon = "checkbox-group-module--with-icon--f2761";